import React from 'react';
import { NavLink } from 'react-router-dom';

function SidebarSignUp() {
   return (
      <sidebar className="ppt_content_sidebar d-none d-lg-flex">
         <h3 className="ppt_sidebar_title mb-5">Sign Up</h3>
         <div className="ppt_sidebar_steps">
            <span data-step="1" className="active">Sign up details</span>
            <span data-step="2">Verify your email</span>
            <span data-step="3">Setup your wallet</span>
            <span data-step="4">Start KYC</span>
         </div>
        <span className="mt-auto"><img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" /></span>
      </sidebar>
   );
}

export default SidebarSignUp;